import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import Alert from "../../assets/images/alert.png";
import "../SignupPages/SignupCommon.css";

const NadPlusPage3: React.FC = () => {
  const [feet, setFeet] = useState<string | null>(null);
  const [inches, setInches] = useState<string | null>(null);
  const [height, setHeight] = useState<number>(0);
  const [weight, setWeight] = useState<string>("");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

   useEffect(() => {
      const step2Completed = localStorage.getItem("completed-step-2");
      if(isSermorelinPage){
        if (step2Completed) {
          navigate("/sermorelin/getting-started/step-3", { replace: true });
        } else {
          navigate("/sermorelin/getting-started/step-2", { replace: true });
        }
      } else{
        if (step2Completed) {
          navigate("/nadplus/getting-started/step-3", { replace: true });
        } else {
          navigate("/nadplus/getting-started/step-2", { replace: true });
        }
      }
    }, []);

  useEffect(() => {
    const savedWeight = localStorage.getItem("weight");
    const savedHeight = localStorage.getItem("height");
    if (savedHeight) {
      try {
        const parsedHeight = JSON.parse(savedHeight);
        const totalHeightInInches = parseInt(parsedHeight.value, 10);
        const feetValue = Math.floor(totalHeightInInches / 12);
        const inchesValue = totalHeightInInches % 12;
        setFeet(feetValue.toString());
        setInches(inchesValue.toString());
        setHeight(totalHeightInInches);
      } catch (error) {
        console.error("Error parsing height from localStorage:", error);
      }
    }
    if (savedWeight) {
      const parsedWeight = JSON.parse(savedWeight);
      setWeight(parsedWeight.value);
    }
  }, []);

  const handleNext = () => {
    if (feet && inches) {
      const feetValue = parseInt(feet, 10);
      const inchesValue = parseInt(inches, 10);
      const totalHeightInInches = feetValue * 12 + inchesValue;
      setHeight(totalHeightInInches);
      localStorage.setItem(
        "height",
        JSON.stringify({ key: "height", value: `${totalHeightInInches}` })
      );
    }

    if (weight) {
      // Store the date in MM/DD/YYYY format in local storage
      localStorage.setItem(
        "weight",
        JSON.stringify({ key: "weight", value: weight })
      );
    }

    localStorage.setItem("completed-step-3", "true");
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-4");
    }else{
      navigate("/nadplus/getting-started/step-4");
    }
  };

  const handleHeightChange = () => {
    if (feet && inches) {
      const feetValue = parseInt(feet, 10);
      const inchesValue = parseInt(inches, 10);
      const totalHeightInInches = feetValue * 12 + inchesValue;
      setHeight(totalHeightInInches);
      localStorage.setItem(
        "height",
        JSON.stringify({ key: "height", value: `${totalHeightInInches}` })
      );
    }
  };

  const handleWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newWeight = e.target.value;
    setWeight(newWeight);

    if (!newWeight || parseFloat(newWeight) <= 0) {
      setError("Weight should be greater than 0.");
      return;
    }

    setError("");
    localStorage.setItem(
      "weight",
      JSON.stringify({ key: "weight", value: newWeight })
    );
  };

  const feetOptions = Array.from({ length: 8 }, (_, i) => ({
    value: (i + 1).toString(),
    label: `${i + 1} ft`,
  }));

  const inchOptions = Array.from({ length: 12 }, (_, i) => ({
    value: i.toString(),
    label: `${i} in`,
  }));

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-2")
    }else{
      navigate("/nadplus/getting-started/step-2")
    } 
  }


  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={30} onBack={handleBack}/>
        <div className="signup-content">
          <p className="signup-intro" style={{ marginBottom: "10px" }}>
            What is your height?
          </p>
          <div className="dropdownAlignment">
            <FormControl fullWidth variant="outlined">
              <InputLabel id="feet-label">Feet</InputLabel>
              <Select
                labelId="feet-label"
                value={feet || ""}
                onChange={(e) => {
                  setFeet(e.target.value);
                  handleHeightChange();
                }}
                label="Feet"
                style={{ borderRadius: "123px", backgroundColor: "#fff" }}
              >
                {feetOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="inches-label">Inches</InputLabel>
              <Select
                labelId="inches-label"
                value={inches || ""}
                onChange={(e) => {
                  setInches(e.target.value);
                  handleHeightChange();
                }}
                label="Inches"
                style={{ borderRadius: "123px", backgroundColor: "#fff" }}
              >
                {inchOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <p className="signup-intro" style={{ marginBottom: "10px" }}>
            What is your weight in pounds?
          </p>

          <input
            id="weight-input"
            type="number"
            value={weight}
            onChange={handleWeightChange}
            placeholder="LBS"
            className="weight-input"
            min="0"
          />
          {error && (
            <div className="state-error">
              <img
                src={Alert}
                alt="state-error"
                width={"16px"}
                height={"15px"}
              />
              <p className="state-error-text">{error}</p>
            </div>
          )}
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={
              !feet ||
              !inches ||
              !weight
            }
          >
            Next →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage3;
